module.exports = __webpack_public_path__ + "static/media/anetwork6.c9c8d07f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/anetwork6.png
// module id = 378
// module chunks = 0